export default "__VITE_ASSET__B8bBr$xB__"